import { api } from "@/shared/api/instance";

export interface CreateManagerRequest {
  login: string;     // Это будет наш Email
  name: string;      // Имя
  surname: string;   // Фамилия
  password?: string; // Если API требует, придется что-то слать (или добавить поле в форму)
  role: string;
}

export const createManager = async (data: CreateManagerRequest) => {
  const response = await api.post('/api/v1/manager', data);
  return response.data;
};
